import axios from 'axios';

//for local website
// const imageBaseUrl = 'http://lushgroom-backend.test';
//for live website
const imageBaseUrl = 'https://admin.lushgroom.com';

/** Laravel API host, aligned with axios.defaults.baseURL (strip trailing /api). */
export function getBackendOrigin() {
  const fallback = imageBaseUrl.replace(/\/$/, '');
  try {
    const base = String(axios.defaults.baseURL || '').trim();
    if (!base) return fallback;
    const origin = base.replace(/\/?api\/?$/i, '').replace(/\/$/, '');
    return origin || fallback;
  } catch {
    return fallback;
  }
}

export function getImageUrl(imagePath) {
  if (!imagePath) {
    return 'https://admin.lushgroom.com/images/categories/69ca005913a0d.png'; // Fallback
    // return 'http://lushgroom-backend.test/images/categories/69ca005913a0d.png'; // Fallback
  }
  // If it's already a full URL, return it as is
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  return `${imageBaseUrl}/${imagePath}`;
}

/**
 * Turn API paths (/storage/..., storage/...) into absolute URLs on the Laravel host.
 * Required when the SPA runs on another origin (e.g. lushgroom-frontend.test) so
 * image URLs are not resolved against the SPA host (where /storage does not exist).
 */
export function resolveBackendAssetUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  const s = String(pathOrUrl).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const path = s.startsWith('/') ? s : `/${s}`;
  const base = getBackendOrigin().replace(/\/$/, '');
  return `${base}${path}`;
}

export function getBookingDownloadUrl(bookingId) {
  const origin = getBackendOrigin().replace(/\/$/, '');
  return `${origin}/api/download-booking/${bookingId}`;
}
